module.exports = __webpack_public_path__ + "static/img/peer-info-bg.db634bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/product-detail/peer-info-bg.png
// module id = 6u4N
// module chunks = 4